export default __webpack_public_path__ + "static/media/fran.385f1716.png";